import {addLocaleData} from 'react-intl';

import asLocaleData from 'react-intl/locale-data/as';
import bnLocaleData from 'react-intl/locale-data/bn';
import brxLocaleData from 'react-intl/locale-data/brx';
import enLocaleData from 'react-intl/locale-data/en';
import guLocaleData from 'react-intl/locale-data/gu';
import hiLocaleData from 'react-intl/locale-data/hi';
import knLocaleData from 'react-intl/locale-data/kn';
import kokLocaleData from 'react-intl/locale-data/kok';
import ksLocaleData from 'react-intl/locale-data/ks';
import mlLocaleData from 'react-intl/locale-data/ml';
import mrLocaleData from 'react-intl/locale-data/mr';
import neLocaleData from 'react-intl/locale-data/ne';
import orLocaleData from 'react-intl/locale-data/or';
import paLocaleData from 'react-intl/locale-data/pa';
import sdLocaleData from 'react-intl/locale-data/sd';
import taLocaleData from 'react-intl/locale-data/ta';
import teLocaleData from 'react-intl/locale-data/te';
import urLocaleData from 'react-intl/locale-data/ur';

import {isRtlLocale, mergedMessagesByLocale} from '../lib/locale-utils';

addLocaleData(asLocaleData);
addLocaleData(bnLocaleData);
addLocaleData(brxLocaleData);
addLocaleData(enLocaleData);
addLocaleData(guLocaleData);
addLocaleData(hiLocaleData);
addLocaleData(knLocaleData);
addLocaleData(kokLocaleData);
addLocaleData(ksLocaleData);
addLocaleData(mlLocaleData);
addLocaleData(mrLocaleData);
addLocaleData(neLocaleData);
addLocaleData(orLocaleData);
addLocaleData(paLocaleData);
addLocaleData(sdLocaleData);
addLocaleData(taLocaleData);
addLocaleData(teLocaleData);
addLocaleData(urLocaleData);

const addAliasLocale = locale => {
    addLocaleData(hiLocaleData.map(d => Object.assign({}, d, {locale})));
};
addAliasLocale('doi');
addAliasLocale('mai');
addAliasLocale('mni');
addAliasLocale('sa');
addAliasLocale('sat');

const UPDATE_LOCALES = 'scratch-gui/locales/UPDATE_LOCALES';
const SELECT_LOCALE = 'scratch-gui/locales/SELECT_LOCALE';

const defaultLocale = process.env.DEFAULT_LANGUAGE || 'or';

const initialState = {
    isRtl: isRtlLocale(defaultLocale),
    locale: defaultLocale,
    messagesByLocale: mergedMessagesByLocale,
    messages: mergedMessagesByLocale[defaultLocale] || mergedMessagesByLocale.or
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case SELECT_LOCALE:
        return Object.assign({}, state, {
            isRtl: isRtlLocale(action.locale),
            locale: action.locale,
            messagesByLocale: state.messagesByLocale,
            messages: state.messagesByLocale[action.locale]
        });
    case UPDATE_LOCALES:
        return Object.assign({}, state, {
            isRtl: state.isRtl,
            locale: state.locale,
            messagesByLocale: action.messagesByLocale,
            messages: action.messagesByLocale[state.locale]
        });
    default:
        return state;
    }
};

const selectLocale = function (locale) {
    return {
        type: SELECT_LOCALE,
        locale: locale
    };
};

const setLocales = function (localesMessages) {
    return {
        type: UPDATE_LOCALES,
        messagesByLocale: localesMessages
    };
};
const initLocale = function (currentState, locale) {
    if (Object.prototype.hasOwnProperty.call(currentState.messagesByLocale, locale)) {
        return Object.assign(
            {},
            currentState,
            {
                isRtl: isRtlLocale(locale),
                locale: locale,
                messagesByLocale: currentState.messagesByLocale,
                messages: currentState.messagesByLocale[locale]
            }
        );
    }
    // don't change locale if it's not in the current messages
    return currentState;
};
export {
    reducer as default,
    initialState as localesInitialState,
    initLocale,
    selectLocale,
    setLocales
};
